import { safeLocalStorage } from './safeStorage';

const AUTH_TOKEN_KEY = 'authToken';

class LocalStorageService {
  getAuthToken() {
    return safeLocalStorage.getItem(AUTH_TOKEN_KEY) ?? undefined;
  }

  // Where storage is denied the token simply doesn't survive a reload — the session
  // still works, the user just signs in again next visit.
  setAuthToken(token?: string) {
    if (token) {
      safeLocalStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
      safeLocalStorage.removeItem(AUTH_TOKEN_KEY);
    }
  }
}

export const localStorageService = new LocalStorageService();
